import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export const saveDraftConsent = async (
    apiProxyPath: string,
    apiKey: string,
    authenticationData: AuthenticationData,
    applicationReferenceNumber: string,
    publicId: string,
    type: 'SBL' | 'NORSK_GJELDSREGISTER',
): Promise<void> => {
    await apiClient<void>(`${apiProxyPath}/drafts/${applicationReferenceNumber}/consents`, {
        method: 'POST',
        body: { publicId, type },
        apiKey,
        authenticationData,
        responseType: 'void',
        sentryTag: 'save_draft_consent',
        sentryExtra: { arn: applicationReferenceNumber, type },
    });
};
